module.exports = __webpack_public_path__ + "img/services.e165ba0.svg?v=1749539050710";